var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppratingBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 181,
    viewBox: "0 0 328 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 181,
    rx: 12,
    fill: "#EBF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4548 27.2259C35.2539 24.867 33.7474 20.7479 32.9998 17C32.2511 20.7487 30.7462 24.8687 28.5445 27.2275C26.3435 29.5847 22.4976 31.1987 19 32.0012C22.499 32.8022 26.3442 34.4152 28.5452 36.7741C30.7461 39.1321 32.2526 43.2521 33.0013 47C33.7489 43.2513 35.255 39.1313 37.4555 36.7725C39.6565 34.4145 43.5024 32.8013 47 31.9988C43.5018 31.1978 39.6566 29.584 37.4548 27.2259Z",
    fill: "#BDCBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.887 151.454C292.707 150.196 291.9 147.999 291.5 146C291.099 147.999 290.293 150.197 289.113 151.455C287.934 152.712 285.874 153.573 284 154.001C285.874 154.428 287.934 155.288 289.113 156.546C290.293 157.804 291.1 160.001 291.501 162C291.901 160.001 292.708 157.803 293.887 156.545C295.066 155.288 297.126 154.427 299 153.999C297.126 153.572 295.066 152.711 293.887 151.454Z",
    fill: "#BDCBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppratingBack);
export default __webpack_public_path__ + "static/media/apprating_back.7f2f0a2854be44a77b28979faec1957a.svg";
export { ForwardRef as ReactComponent };